import { render, staticRenderFns } from "./AvatarDescription.vue?vue&type=template&id=de585086&scoped=true&"
import script from "./AvatarDescription.vue?vue&type=script&lang=ts&"
export * from "./AvatarDescription.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarDescription.vue?vue&type=style&index=0&id=de585086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de585086",
  null
  
)

export default component.exports